<template>
<div>
    <article class="agreement-text">
        <h4 class="tit">《个人征信及用户信息授信书-众安保险》</h4>

        <p class="tc"><strong>个人征信授权书及用户信息授权书</strong></p>
        <p class="tr"><strong>签订地：上海市浦东新区</strong></p>

        <p><strong><span class="baseline">重要提示：本次授权文件包含《个人征信授权书》、《用户信息授权书》（统称“授权书”），</span>为了保障您的合法权益，请您务必审慎阅读、充分理解授权书条款内容，特别是您在授权书范围内的权利和义务。</strong></p>

        <p><strong>您的点击确认及业务申请使用等行为即视为您已阅读、理解并同意签署《个人征信授权书》、《用户信息授权书》，并授权众安在线财产保险股份有限公司向合作的电子合同服务商代您申请开通及调用您的电子签名，以签署授权书。您认可电子签名签署授权书的法律效力，并受签署的授权书约束。如授权书包含至相应业务协议中，对相应业务协议接受同意即视为您已阅读、理解并同意授权书内容。</strong></p>

        <p class="tc noindent"><strong>个人征信授权书</strong></p>

        <p class="noindent">众安在线财产保险股份有限公司：</p>

        <p>本人{{userName}},身份证号码 {{certNo}},本人同意在本人作为投保人、被保险人以及保险标的的履约义务人与贵公司办理或涉及本人的如下信用保证保险业务或事项中：<strong class="baseline">1、保前审核；2、保中管理；3、保后管理（包括保险理赔与追偿）；4、处理本人征信异议</strong>，就本人的个人征信信息作出以下授权并清楚理解其含义：</p>

        <p><strong>(一)本人同意授权贵公司自行或委托第三方机构向中国人民银行金融信用信息基础数据库、其他依法成立的征信机构查询、打印、留存、使用本人的个人信息、信用信息及上述机构留存的本人其他全部信息。</strong></p>

        <p><strong>贵公司超出授权查询的一切后果及法律责任由贵公司自行承担。</strong></p>

        <p><strong>(二)本人同意授权贵公司自行或委托第三方机构向中国人民银行金融信用信息基础数据库、其他依法成立的征信机构提供、报送、上传因本业务或事项产生的本人全部信息（包括信用保证保险业务中产生的不良信息等）。贵公司有权通过本人在贵公司登记的移动电话号码或其他通讯方式向本人发送不良信息报送提醒通知。本人承诺承担因移动电话号码或其他通讯方式发生变更等未及时告知贵公司而导致本人未收到不良信息报送提醒通知的一切法律后果。如本人未按时还款，本人同意并授权贵公司在按照保险合同约定履行赔付义务后有权向上述机构提供、报送、上传本人不良信息。</strong>上述机构可依法对本人信息进行整理、保存、加工、使用、提供，并出具个人模型结果。本人已清楚知悉提供上述信息可能会给本人带来财产或信用损失，以及其他可能的不利后果，包括但不限于：<strong>采集这些信息对本人的信用评级(评分)、信用报告等结果可能产生的不利影响，以及该等信息被信息使用者依法提供给第三方后被他人不当利用的风险。</strong></p>

        <p><strong>（三）以上授权的期限为本人作出本授权承诺之日起至本人在贵公司办理或涉及的所有业务或事项终结之日止。若本人在贵公司处办理或涉及的业务未获批准，本人同意贵公司继续保留此查询授权书原件和身份证复印件或影印件。</strong></p>

        <p><strong>特别提示:</strong></p>

        <p>若本人与被授权人发生因本授权书而产生的任何纠纷或争议，首先应友好协商解决；协商不成的，<strong>本人同意将纠纷或争议提交至本授权书签订地有管辖权的人民法院诉讼解决。</strong>本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</p>

        <p>本人承诺本授权书生效后即不可撤销且具有独立性，不因相关业务合同或条款无效或被撤销而无效或失效<strong>。</strong></p>

        <p><strong>本人已知悉本授权书全部内容(特别是加粗字体内容)的含义及因此产生的法律效力，自愿做出以上授权。本授权是本人真实意思表示，本人愿意承担由此带来的一切法律后果。</strong></p>

        <p><strong>特此授权！</strong></p>

        <p class="tr">授权人: {{userName}}</p>

        <p class="tr">日 期: {{nowDate}}</p>

        <p class="tc"><strong>用户信息授权书</strong></p>

        <p>众安在线财产保险股份有限公司：</p>

        <p>本人 {{userName}},身份证号码 {{certNo}},本人同意在本人作为投保人、被保险人以及保险标的的履约义务人与贵公司办理或涉及本人的如下信用保证保险业务或事项中：<strong class="baseline">1、保前审核；2、保中管理；3、保后管理（包括保险理赔与追偿）；4、依法或经有权部门要求或相关业务协议约定等，</strong>就本人个人信息作出以下授权并清楚理解其含义：</p>

        <p><strong>（一）本人同意贵公司有权搜集、保留、使用、加工本人与贵公司办理上述业务或事项过程中提供的全部信息，包括但不限于本人姓名、身份证件类型、证件号码、手机号码、银行卡号等。</strong></p>

        <p><strong>（二）本人同意授权贵公司自行或委托第三方机构向如下机构查询、打印、留存、使用本人的基本、信用、通讯、交易、公共事业、缴税、借贷、财产信息及如下机构留存的本人其他全部信息：</strong></p>

        <p><strong>1.行政机关、事业单位、司法机关、监管部门、中国互联网金融协会、中国支付清算协会等有权部门、行业自律组织等；</strong></p>

        <p><strong>2.有资质的数据服务公司；</strong></p>

        <p><strong>3.其他有权留存本人信息的机构等。</strong></p>

        <p><strong>（三）本人同意授权贵公司将本人信息用于与上述业务有关的身份验证、信息准确性验证、资格审核、信用评估、客户服务、安全防范、诈骗监测、存档和备份等用途，以确保贵公司提供的产品和服务的适当性和安全性。同时，贵公司有权按照相关法律法规及监管要求进行本人身份证件核对和实名信息查验登记。</strong></p>

        <p><strong>（四）本人同意授权贵公司自行或将本人信息传递至具备合法资质的第三方机构并委托其对本人信息进行实名验证、密码验证、短信验证、银行卡鉴权等一个或多个方式验证。</strong></p>

        <p><strong>（五）以上授权的期限为本人作出本授权承诺之日起至本人在贵公司办理或涉及的所有业务或事项终结之日止。若本人在贵公司处办理或涉及的业务未获批准，本人同意贵公司继续保留此查询授权书原件和身份证复印件或影印件。</strong></p>

        <p><strong>中互金特别授权条款：</strong></p>

        <p><strong>本人完全理解并不可撤销地、免费地授予贵司及其信息共享合作伙伴下列权利：</strong></p>

        <p><strong>1、本协议所称的信息共享合作伙伴指与贵司共同加入中国互联网金融协会互联网>金融信息共享平台的其他单位。</strong></p>

        <p><strong>2、本人同意和授权贵司收集并向中国互联网金融协会报送本人的保险信息，并同意中国互联网金融协会获取、保存、分析处理该保险信息，报送的保险信息包括但不限于主体信息、保单承保信息、代偿信息、追偿信息,以及提供虚假申请资料等欺诈信息（以下简称“保险信息”）。</strong></p>

        <p><strong>3、本人同意并授权贵司及贵司信息共享合作伙伴可在本人保险业务申请阶段及业务存续期间向中国互联网金融协会互联网金融信息共享平台查询本人的保险信息。</strong></p>

        <p><strong>4、本人授权贵司办理以下业务时，可以通过姓名或名称、证件类型、证件号码向中国互联网金融协会互联网金融信息共享平台查询您本人保险信息：</strong></p>

        <p><strong>（1）保前审核（包括本人作为投保人、被保险人或保险标的的履约义务人）；</strong></p>

        <p><strong>（2）保后管理；</strong></p>

        <p><strong>（3）审核本人（或配偶）作为担保人的业务；</strong></p>

        <p><strong>（4）经中国互联网金融协会同意的其他情况。</strong></p>

        <p><strong>特别提示:</strong></p>

        <p>若本人与被授权人发生因本授权书而产生的任何纠纷或争议，首先应友好协商解决；协商不成的，<strong>本人同意将纠纷或争议提交至本授权书签订地有管辖权的人民法院诉讼解决。</strong>本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。</p>

        <p>本人承诺本授权书生效后即不可撤销且具有独立性，不因相关业务合同或条款无效或被撤销而无效或失效。</p>

        <p><strong>本人已知悉本授权书全部内容(特别是加粗字体内容)的含义及因此产生的法律效力，自愿做出以上授权。本授权是本人真实意思表示，本人愿意承担由此带来的一切法律后果。</strong></p>

        <p><strong>特此授权！</strong></p>

        <p class="tr">授权人: {{userName}}</p>

        <p class="tr">日 期: {{nowDate}}</p>

    </article>
</div>
</template>

<script>
    import {getNow} from '../utils/tool'
    export default {
        data () {
            return {
                userName:'__________',
                certNo:'__________',
                nowDate:''
            }
        },
        mounted(){
            let urlParam=this.$route.query
            if(urlParam.userName){
                this.userName=decodeURIComponent(urlParam.userName)
            }
            if(urlParam.certNo){
                this.certNo=decodeURIComponent(urlParam.certNo)
            }
            this.nowDate=getNow().split(' ')[0]
            console.log(this.nowDate,'nnnnn');

        },
        beforeRouteEnter (to, from, next) {
            document.title = '征信授权协议'
            next()
        }
    }
</script>
<style lang="scss" scoped>

article {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-top: 10px;
  text-align: justify;
  position: relative;
  box-sizing: border-box;

  h4 {
    font-weight: bold;
  }

  strong {
    font-weight: bold;
  }

  span,
  strong {
    display: inline;
  }

  .tl {
    text-align: left;
  }

  .tr {
    text-align: right;
  }

  .tc {
    text-align: center;
  }

  p {
    padding: r(5) 0;
    text-indent: 2em;
  }

  .noindent {
    text-indent: 0;
  }

  h4 {
    text-align: center;
    padding: r(15) 0;
  }

  .indent {
    text-indent: 2em;
  }

  .baseline {
    text-decoration: underline;
    font-weight: bold;
  }

  span.baseline {
    display: inline;
  }
}
</style>




// WEBPACK FOOTER //
// contract.vue?2d1895f5